// Inertia.js entrypoint for React
import React from 'react'
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../../../components/trips/app/frontend/styles/globals.css'

// Force Vite to track component dependencies
if (import.meta.hot) {
  // Import all components to ensure HMR tracking
  const components = import.meta.glob('../../../components/trips/app/frontend/components/**/*.{jsx,tsx}', { eager: false })

  // Accept changes to any component
  Object.keys(components).forEach(path => {
    import.meta.hot?.accept(path, () => {
      window.location.reload()
    })
  })
}

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../../../components/trips/app/frontend/pages/**/*.{jsx,tsx}', { eager: true })
    const jsxPath = `../../../components/trips/app/frontend/pages/${name}.jsx`
    const tsxPath = `../../../components/trips/app/frontend/pages/${name}.tsx`
    const component = pages[jsxPath] || pages[tsxPath]

    if (!component) {
      console.error(`Component ${name} not found. Available pages:`, Object.keys(pages))
      throw new Error(`Page component ${name} not found`)
    }

    return component.default || component
  },
  setup({ el, App, props }) {

    if (!el) {
      console.error('No element found for Inertia app')
      return
    }

    try {
      const root = createRoot(el)
      root.render(<App {...props} />)
    } catch (error) {
      console.error('Error rendering app:', error)
    }
  },
})/* Force rebuild */
